import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import Rightcontainer from "../Components/Rightcontainer";
import axios from "axios";
import Header from '../Components/Header';
import { Link } from "react-router-dom";
import {
  FaArrowLeft,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaCoins,
  FaGamepad,
  FaBan,
  FaExclamationTriangle,
  FaTrophy,
  FaSkull
} from "react-icons/fa";

const Gamehistory = () => {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;

  let baseUrl;
  if (nodeMode === "development") {
    baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  const [user, setUser] = useState(null);
  const [game, setGame] = useState([]);
  const [loading, setLoading] = useState(true);
  const limit = 10;
  const [pageNumber, setPageNumber] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalWins, setTotalWins] = useState(0);
  const [totalLoses, setTotalLoses] = useState(0);
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };


  const role = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`
    };
    try {
      const res = await axios.get(baseUrl + `me`, { headers });
      setUser(res.data);
      if (res.data && res.data._id) {
        Allgames(res.data._id, pageNumber);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error("Error fetching user:", err);
      setLoading(false);
    }
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
  };

  const Allgames = async (id, pageNum) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`
    };
    try {
      const res = await axios.get(baseUrl + `game/history/user/${id}?page=${pageNum}&_limit=${limit}`, { headers });
      if (res.data && res.data.data) {
        setGame(res.data.data || []);
        setTotalRecords(res.data.total_records || 0);
        setTotalWins(res.data.total_wins || 0);
        setTotalLoses(res.data.total_loses || 0);
        setNumberOfPages(res.data.totalPages || 0);
      }
    } catch (err) {
      console.error("Error fetching battle history:", err);
    } finally {
      setLoading(false);
    }
  };

  const getFormattedDate = (e) => {
    if (!e) return { date: "N/A", time: "" };
    const date = new Date(e);
    if (isNaN(date.getTime())) return { date: "N/A", time: "" };
    const dateStr = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    return { date: dateStr, time: timeStr };
  };

  useEffect(() => {
    role();
    // eslint-disable-next-line
  }, [pageNumber]);





  return (
    <div style={{ backgroundColor: "#0b1426", minHeight: "100vh", color: "#fff" }}>
      {/* Embedded CSS for premium UI styling and transitions - styled EXACTLY like transaction history */}
      <style>{`
        .ref-card-bg {
          position: relative;
          background: linear-gradient(135deg, rgba(20, 35, 60, 0.9) 0%, rgba(13, 23, 42, 0.95) 100%);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 16px;
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
          overflow: hidden;
        }
        .ref-card-bg::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 4px;
          background: transparent;
          transition: all 0.3s ease;
        }
        .ref-card-bg.battle-win::before {
          background: linear-gradient(to bottom, #3cd63c, #1ba94c);
        }
        .ref-card-bg.battle-lose::before {
          background: linear-gradient(to bottom, #dc3545, #b31b28);
        }
        .ref-card-bg.battle-running::before {
          background: linear-gradient(to bottom, #ffc107, #d39e00);
        }
        .ref-card-bg.battle-cancelled::before {
          background: linear-gradient(to bottom, #6c757d, #495057);
        }
        .ref-card-bg.battle-conflict::before {
          background: linear-gradient(to bottom, #e83e8c, #a01555);
        }
        .ref-card-bg.battle-open::before {
          background: linear-gradient(to bottom, #00c6ff, #0072ff);
        }
        .ref-card-bg.battle-timeout::before {
          background: linear-gradient(to bottom, #ff9900, #ff5500);
        }
        .ref-card-bg:hover {
          transform: translateY(-4px);
          border-color: rgba(60, 214, 60, 0.4);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.4);
        }
        .gradient-header {
          background: linear-gradient(135deg, #1e3c72 0%, #1a2a6c 50%, #240b36 100%);
          border-bottom: 2px solid rgba(255, 255, 255, 0.1);
        }
        .stat-card {
          background: rgba(255, 255, 255, 0.04);
          border: 1px solid rgba(255, 255, 255, 0.06);
          border-radius: 12px;
          padding: 12px 16px;
          flex: 1;
          display: flex;
          align-items: center;
          gap: 12px;
          transition: all 0.3s ease;
        }
        .stat-card:hover {
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(255, 255, 255, 0.15);
          transform: translateY(-2px);
        }
        .search-container {
          position: relative;
          width: 100%;
        }
        .search-input {
          width: 100%;
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 12px;
          padding: 10px 16px;
          color: #fff;
          font-size: 0.88rem;
          transition: all 0.3s ease;
        }
        .search-input:focus {
          outline: none;
          background: rgba(255, 255, 255, 0.06);
          border-color: #3cd63c;
          box-shadow: 0 0 15px rgba(60, 214, 60, 0.2);
        }
        .filter-tab-bar {
          display: flex;
          overflow-x: auto;
          gap: 8px;
          padding: 4px 0 12px 0;
          margin-bottom: 8px;
          scrollbar-width: none;
        }
        .filter-tab-bar::-webkit-scrollbar {
          display: none;
        }
        .filter-pill {
          display: flex;
          align-items: center;
          gap: 6px;
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.06);
          color: rgba(255, 255, 255, 0.6);
          padding: 8px 14px;
          border-radius: 20px;
          font-size: 0.78rem;
          font-weight: 500;
          cursor: pointer;
          white-space: nowrap;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .filter-pill:hover {
          color: #fff;
          background: rgba(255, 255, 255, 0.08);
          border-color: rgba(255, 255, 255, 0.15);
        }
        .filter-pill.active {
          color: #0b1426;
          background: #3cd63c;
          border-color: #3cd63c;
          font-weight: 600;
          box-shadow: 0 4px 12px rgba(60, 214, 60, 0.3);
        }
        .animate-fade-in {
          animation: fadeIn 0.6s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .status-badge-success {
          background: rgba(60, 214, 60, 0.15);
          color: #3cd63c;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(60, 214, 60, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .status-badge-pending {
          background: rgba(255, 193, 7, 0.15);
          color: #ffc107;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(255, 193, 7, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .status-badge-failed {
          background: rgba(220, 53, 69, 0.15);
          color: #dc3545;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(220, 53, 69, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .status-badge-conflict {
          background: rgba(232, 62, 140, 0.15);
          color: #e83e8c;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(232, 62, 140, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .status-badge-cancelled {
          background: rgba(108, 117, 125, 0.15);
          color: #6c757d;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(108, 117, 125, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .status-badge-open {
          background: rgba(0, 198, 255, 0.15);
          color: #00c6ff;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(0, 198, 255, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .status-badge-timeout {
          background: rgba(255, 153, 0, 0.15);
          color: #ff9900;
          font-size: 0.72rem;
          padding: 4px 10px;
          border-radius: 20px;
          border: 1px solid rgba(255, 153, 0, 0.3);
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .hover-highlight:hover {
          filter: brightness(1.3);
        }
        .hover-underline:hover {
          text-decoration: underline;
          color: #3cd63c !important;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .pagination {
          display: flex;
          padding-left: 0;
          list-style: none;
          border-radius: 0.25rem;
          justify-content: center;
          align-items: center;
          gap: 6px;
        }
        .page-item .page-link {
          background: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.1) !important;
          color: #fff !important;
          padding: 8px 16px;
          border-radius: 8px !important;
          transition: all 0.2s;
        }
        .page-item:hover .page-link {
          background: rgba(60, 214, 60, 0.2) !important;
          border-color: rgba(60, 214, 60, 0.4) !important;
          color: #3cd63c !important;
          text-decoration: none !important;
        }
        .page-item.active .page-link {
          background: #3cd63c !important;
          border-color: #3cd63c !important;
          color: #0b1426 !important;
          font-weight: bold;
        }
        .page-item.disabled .page-link {
          opacity: 0.4;
          cursor: not-allowed;
          background: rgba(255, 255, 255, 0.02) !important;
        }
      `}</style>

      <Header user={user} />
      <div className="leftContainer animate-fade-in" style={{ minHeight: '100vh', height: '100%', paddingBottom: "100px" }}>

        {/* Dynamic Gradient Header Panel - matches the purple-blue gradient in Transactionhistory */}
        <div className="gradient-header p-4 text-white">
          <div className="d-flex align-items-center mb-3">
            <Link to="/" className="text-white mr-3 d-flex align-items-center justify-content-center" style={{ textDecoration: "none" }}>
              <FaArrowLeft size={18} />
            </Link>
            <h4 className="m-0 font-weight-bold" style={{ letterSpacing: "0.5px" }}>Battle History</h4>
          </div>

          <p className="text-white-50 small mb-4">
            Track all your ludo match details, victory rewards, defeats, and running battles instantly.
          </p>

          <div className="d-flex flex-wrap gap-3" style={{ gap: "12px" }}>
            <div className="stat-card">
              <div style={{ background: "rgba(30, 144, 255, 0.15)", borderRadius: "10px", padding: "10px", color: "#1e90ff" }}>
                <FaGamepad size={20} />
              </div>
              <div>
                <div className="text-white-50" style={{ fontSize: "0.75rem" }}>Total Records</div>
                <h5 className="m-0 font-weight-bold">{totalRecords}</h5>
              </div>
            </div>

            <div className="stat-card">
              <div style={{ background: "rgba(60, 214, 60, 0.15)", borderRadius: "10px", padding: "10px", color: "#3cd63c" }}>
                <FaTrophy size={20} />
              </div>
              <div>
                <div className="text-white-50" style={{ fontSize: "0.75rem" }}>Total Wins</div>
                <h5 className="m-0 font-weight-bold" style={{ color: "#3cd63c" }}>{totalWins}</h5>
              </div>
            </div>

            <div className="stat-card">
              <div style={{ background: "rgba(220, 53, 69, 0.15)", borderRadius: "10px", padding: "10px", color: "#dc3545" }}>
                <FaSkull size={20} />
              </div>
              <div>
                <div className="text-white-50" style={{ fontSize: "0.75rem" }}>Total Loses</div>
                <h5 className="m-0 font-weight-bold" style={{ color: "#dc3545" }}>{totalLoses}</h5>
              </div>
            </div>
          </div>
        </div>

        {/* Loading State */}
        {loading ? (
          <div className="d-flex flex-column align-items-center justify-content-center pt-5" style={{ minHeight: "35vh" }}>
            <div className="spinner-border text-success" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="mt-3 text-white-50 small">Loading battles...</div>
          </div>
        ) : (
          <div className="mt-4 px-3">
            {Array.isArray(game) && game.length > 0 ? (
              <div>
                {game.map((card, index) => {
                  const idStr = card._id ? card._id.toString() : "";
                  const timestampStr = idStr.slice(0, 8);
                  const counterid = parseInt(timestampStr, 16) || Math.floor(Math.random() * 1000000);

                  let signIcon = <FaGamepad className="text-info" size={18} />;
                  let cardClass = "ref-card-bg p-3 mb-3 d-flex align-items-center justify-content-between";
                  let titleMsg = "Battle Challenge";
                  let badge = null;
                  let amountColor = "#fff";
                  let signStr = "";
                  let amountToDisplay = card.Game_Ammount || 0;

                  const status = card.Status ? card.Status.toString().toLowerCase() : null;

                  if (status === "new") {
                    cardClass += " battle-open";
                    titleMsg = "Open Challenge";
                    signIcon = <FaGamepad className="text-info" size={18} />;
                    badge = (
                      <span className="status-badge-open">
                        <FaGamepad size={10} style={{ transform: "scale(1.1)" }} /> Open Challenge
                      </span>
                    );
                    amountColor = "#00c6ff";
                  } else if (!status || status === "null" || status === "none") {
                    cardClass += " battle-timeout";
                    titleMsg = "Timed Out";
                    signIcon = <FaClock className="text-warning" size={18} />;
                    badge = (
                      <span className="status-badge-timeout">
                        <FaClock size={10} /> Time Out
                      </span>
                    );
                    amountColor = "#ff9900";
                  } else if (status === "running") {
                    cardClass += " battle-running";
                    titleMsg = "Battle Running";
                    signIcon = <FaClock className="text-warning" size={18} style={{ animation: "spin 4s linear infinite" }} />;
                    badge = (
                      <span className="status-badge-pending">
                        <FaClock size={10} /> Running
                      </span>
                    );
                    amountColor = "#ffc107";
                  } else if (status === "cancelled") {
                    cardClass += " battle-cancelled";
                    titleMsg = "Battle Cancelled";
                    signIcon = <FaBan className="text-secondary" size={18} />;
                    badge = (
                      <span className="status-badge-cancelled">
                        <FaBan size={10} /> Cancelled
                      </span>
                    );
                    amountColor = "#6c757d";
                  } else if (status === "conflict") {
                    cardClass += " battle-conflict";
                    titleMsg = "Battle Conflict";
                    signIcon = <FaExclamationTriangle className="text-danger" size={18} />;
                    badge = (
                      <span className="status-badge-conflict">
                        <FaExclamationTriangle size={10} /> Conflict
                      </span>
                    );
                    amountColor = "#e83e8c";
                  } else if (status === "completed") {
                    const isWinner = card.winner_user && card.winner_user._id === user?._id;
                    if (isWinner) {
                      cardClass += " battle-win";
                      titleMsg = "Victory!";
                      signIcon = <FaTrophy className="text-success" size={18} style={{ filter: "drop-shadow(0 0 4px rgba(60,214,60,0.5))" }} />;
                      badge = (
                        <span className="status-badge-success">
                          <FaCheckCircle size={10} /> Victory
                        </span>
                      );
                      amountColor = "#3cd63c";
                      signStr = "+";
                      amountToDisplay = card.winnAmount || (card.Game_Ammount * 1.9);
                    } else {
                      cardClass += " battle-lose";
                      titleMsg = "Defeat";
                      signIcon = <FaSkull className="text-danger" size={18} />;
                      badge = (
                        <span className="status-badge-failed">
                          <FaTimesCircle size={10} /> Defeat
                        </span>
                      );
                      amountColor = "#dc3545";
                      signStr = "-";
                      amountToDisplay = card.Game_Ammount || 0;
                    }
                  }

                  const { date: displayDate, time: displayTime } = getFormattedDate(card.created_at || card.createdAt);

                  const acceptorId = card.Accepetd_By && typeof card.Accepetd_By === 'object'
                    ? card.Accepetd_By._id
                    : card.Accepetd_By;
                  
                  const isUserAcceptor = acceptorId === user?._id;
                  
                  const opponentName = isUserAcceptor
                    ? (card.creator?.Name || "Opponent")
                    : (card.accepted_by?.Name || "Waiting for Player");

                  const displayRoomCode = card.Room_code && card.Room_code !== 0 && card.Room_code !== "0"
                    ? card.Room_code
                    : (card.Room_Code && card.Room_Code !== 0 && card.Room_Code !== "0" ? card.Room_Code : "Pending");

                  const isCreator = card.Created_by === user?._id || (card.creator && card.creator._id === user?._id);
                  const isWinner = card.winner_user && card.winner_user._id === user?._id;
                  const closingBalanceVal = status === "completed"
                    ? (isWinner ? card.Winner_closingbalance : card.Loser_closingbalance)
                    : (isCreator ? card.Winner_closingbalance : card.Loser_closingbalance);

                  return (
                    <div className={cardClass} key={card._id || index}>
                      <div className="d-flex align-items-center gap-3" style={{ gap: "14px" }}>
                        <div style={{
                          width: "45px",
                          height: "45px",
                          borderRadius: "12px",
                          background: "rgba(255,255,255,0.05)",
                          border: "1px solid rgba(255,255,255,0.08)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "inset 0 1px 3px rgba(255,255,255,0.05)"
                        }}>
                          {signIcon}
                        </div>
                        <div>
                          <div className="font-weight-bold text-white mb-1" style={{ fontSize: "0.95rem", display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px" }}>
                            <span>{titleMsg}</span>
                            <span className="text-white-50 font-weight-normal small">vs {opponentName}</span>
                            <span className="badge badge-dark text-white-50" style={{ background: "rgba(255, 255, 255, 0.05)", border: "1px solid rgba(255,255,255,0.08)", fontSize: "0.62rem", padding: "2px 6px", borderRadius: "6px" }}>
                              {card.Game_type || "Ludo"}
                            </span>
                          </div>
                          <div className="text-white-50 small d-flex flex-wrap align-items-center gap-2" style={{ gap: "8px", fontSize: "0.72rem" }}>
                            {displayRoomCode !== "Pending" ? (
                              <span 
                                onClick={() => handleCopy(displayRoomCode, card._id)} 
                                style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "4px" }}
                                title="Click to copy Room Code"
                                className="hover-highlight"
                              >
                                Room: <strong className="text-white hover-underline" style={{ color: "#3cd63c !important" }}>{displayRoomCode}</strong>
                                {copiedId === card._id ? (
                                  <span className="text-success font-weight-bold" style={{ fontSize: "0.65rem", marginLeft: "2px" }}>✓ Copied</span>
                                ) : (
                                  <span className="text-white-50" style={{ fontSize: "0.65rem", marginLeft: "2px", opacity: 0.7 }}>📋 Copy</span>
                                )}
                              </span>
                            ) : (
                              <span>Room Code: <strong className="text-white-50" style={{ fontStyle: "italic" }}>Waiting</strong></span>
                            )}
                            <span className="text-secondary">•</span>
                            <span>{displayDate} {displayTime}</span>
                          </div>
                        </div>
                      </div>

                      <div className="text-right">
                        <div className="d-flex align-items-center justify-content-end gap-1 mb-1" style={{ gap: "4px" }}>
                          <picture>
                            <img
                              alt="coins"
                              height="16px"
                              width="16px"
                              src={process.env.PUBLIC_URL + '/Images/kd_ludo/coin_icon.gif'}
                              style={{ display: "inline-block", verticalAlign: "middle" }}
                            />
                          </picture>
                          <span style={{ fontSize: "1.1rem", fontWeight: "bold", color: amountColor }}>
                            {signStr}₹{amountToDisplay}
                          </span>
                        </div>

                        <div className="d-flex align-items-center justify-content-end gap-2" style={{ gap: "8px" }}>
                          {badge}
                          {closingBalanceVal !== undefined && closingBalanceVal !== null && (
                            <span className="text-white-50" style={{ fontSize: "0.68rem" }}>
                              Closing: ₹{closingBalanceVal}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* Paginate wrapper */}
                {numberOfPages > 1 && (
                  <div className="py-4">
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={numberOfPages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={pageNumber - 1}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="text-center px-4 py-5 animate-fade-in" style={{ marginTop: "15%" }}>
                <img
                  src={process.env.PUBLIC_URL + '/Images/nogamehistory.png'}
                  alt="no battles"
                  width={220}
                  height={220}
                  className="img-fluid mb-4"
                  style={{ opacity: 0.8 }}
                />
                <h4 className="font-weight-bold">No Battles Found</h4>
                <p className="text-white-50 mx-auto small" style={{ maxWidth: "300px" }}>
                  Matches you join, play, or complete will show up in this history section.
                </p>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Gamehistory;